import * as React from "react";
import "./labeled-input.css";
import { Popup } from "semantic-ui-react";

export default function LabeledInput({
                                         label,
                                         inputElement,
                                         required = false,
                                         desc = undefined
                                     }: {
    label: string;
    inputElement: JSX.Element;
    required?: boolean;
    desc?: string;
}): JSX.Element {
    const labelFinal = `${label}${required ? " *" : ""}`

    return (
        <div className="labeledInput">
            <div className="label">
                {desc === undefined && labelFinal}
                {desc !== undefined && <Popup content={desc} trigger={<span className="labelWithPopup">{labelFinal}</span>}/>}
            </div>
            <div className="input">{inputElement}</div>
        </div>
    );
}
